<template>
  <div v-if="leadSourceData.length" class="flex gap-2">
    <router-link class="flex gap-2" to="/settings/company/advertising">
      <Badge v-for="source in leadSourceData" :key="source.type" variant="indigo">{{ source.value }}</Badge>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Badge } from '@/components/ui/badge';
import type { ContactDetail } from './ContactDetail';

type LeadSource = { type: string; value: string };

const props = defineProps<{ contact: ContactDetail }>();

const leadSourceData = computed<LeadSource[]>(() => {
  const ap = props.contact.attributionParams;

  if (!ap || Object.keys(ap).length === 0) return [];

  return Object.keys(ap)
    .map(key => ({ type: key, value: String(ap[key]) }))
    .filter(source => !source.value.toLowerCase().includes('referral'));
});
</script>
